import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'mutationobserver-shim'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/bootstrap-vue'
import './plugins/vee-validate'
import Notifications from 'vue-notification'

import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import 'moment/locale/ko'

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.use(VueMomentJS, moment)
Vue.use(Notifications)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
